import { ClientConfig } from '@/__configs/config_types';
import { DeepPartial } from '@/redux/slices/slice_types';
import theme from './theme';

const config: DeepPartial<ClientConfig> = {
  clientName: 'Focus',
  theme,
  orderPlacementConfig: {
    entityTypes: ['series', 'movie']
  },
  userColors: ['#aa6600', '#118833', '#dd3333', '#952a9f', '#cc4455', '#71a400', '#667799', '#bb44aa', '#8855ee', '#5566ee', '#4466ff', '#dd2277'],
  versionColors: {
    simulcast: '#00a197',
    uncut: '#76AAF1',
    episode: '#00a197',
    movie: '#76AAF1'
  }
};

export default config;
